import React, { useState } from 'react';
import '../styles/credits-expander.css';

const CreditsExpander = ({ content }) => {
    const [creditsVisible, setCreditsVisible] = useState(false);
    const expanderIcon = creditsVisible ? '-' : '+';

    // Determine what to render inside
    const renderContent = () => {
        if (typeof content === 'string') {
            return (
                <div dangerouslySetInnerHTML={{ __html: content }} />
            );
        } else if (React.isValidElement(content)) {
            // If content is a React element, render directly
            return content;
        } else {
            // Fallback: Stringify and display
            return <pre>{JSON.stringify(content, null, 2)}</pre>;
        }
    };

    return (
        <div className='credits-expander'>
            <div className='credits-button-wrapper'>
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setCreditsVisible(!creditsVisible);
                    }}
                >
                    Credits
                </a>
                <span onClick={() => setCreditsVisible(!creditsVisible)}>{expanderIcon}</span>
            </div>
            <div className='credits-content'>
                {creditsVisible && renderContent()}
            </div>
        </div>
    );
};

export default CreditsExpander;
